<template>
  <span
    v-if="shortText"
    class="charge-memo-cell"
    :class="{ 'charge-memo-cell--has-tip': showTooltip }"
  >
    <span class="charge-memo-cell__text">{{ shortText }}</span>
    <span v-if="showTooltip" class="charge-memo-cell__tip" role="tooltip">{{ tooltipText }}</span>
  </span>
  <span v-else class="charge-memo-cell">-</span>
</template>

<script>
import { formatChargeMemoShort, formatChargeMemoTooltip } from '@/utils/wallet'

export default {
  name: 'ChargeMemoCell',
  props: {
    memo: {
      type: String,
      default: ''
    }
  },
  computed: {
    shortText () {
      return formatChargeMemoShort(this.memo)
    },
    tooltipText () {
      return formatChargeMemoTooltip(this.memo)
    },
    showTooltip () {
      const short = this.shortText
      const tip = this.tooltipText
      if (!short || !tip) return false
      return tip !== short || String(this.memo || '').trim().length > short.length
    }
  }
}
</script>

<style scoped>
.charge-memo-cell {
  position: relative;
  display: inline-block;
  max-width: 100%;
  text-align: left;
  vertical-align: top;
}

.charge-memo-cell__text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  word-break: break-word;
  line-height: 1.35;
  cursor: default;
}

.charge-memo-cell--has-tip .charge-memo-cell__text {
  cursor: help;
}

.charge-memo-cell__tip {
  position: absolute;
  left: 50%;
  bottom: calc(100% + 8px);
  z-index: 40;
  min-width: 180px;
  max-width: min(360px, 70vw);
  padding: 10px 12px;
  border-radius: 8px;
  background: rgba(12, 14, 18, 0.96);
  border: 1px solid rgba(212, 175, 55, 0.35);
  color: #f3e6c0;
  font-size: 12px;
  line-height: 1.5;
  white-space: pre-line;
  word-break: break-word;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);
  transform: translateX(-50%);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.15s ease;
}

.charge-memo-cell--has-tip:hover .charge-memo-cell__tip,
.charge-memo-cell--has-tip:focus-within .charge-memo-cell__tip {
  opacity: 1;
  visibility: visible;
}
</style>
